<app-auth-base-layout [title]="'Cambiar contraseña'">
    <ng-container auth-content>
        <div class="alert alert-warning mb-4 py-2 small">
            Tu cuenta tiene una contraseña temporal. Debes establecer una contraseña personal para continuar.
        </div>

        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
            <div class="mb-3">
                <label cLabel for="current_password">Contraseña temporal (actual)</label>
                <input
                    cFormControl
                    type="password"
                    id="current_password"
                    formControlName="current_password"
                    placeholder="••••••••"
                    [class.is-valid]="isValid('current_password')"
                    [class.is-invalid]="isInvalid('current_password')"
                />
                @if (getError('current_password')) {
                    <p class="text-danger small mt-1">{{ getError('current_password') }}</p>
                }
            </div>

            <div class="mb-3">
                <label cLabel for="new_password">Nueva contraseña</label>
                <input
                    cFormControl
                    type="password"
                    id="new_password"
                    formControlName="new_password"
                    placeholder="••••••••"
                    [class.is-valid]="isValid('new_password')"
                    [class.is-invalid]="isInvalid('new_password')"
                />
                @if (getError('new_password')) {
                    <p class="text-danger small mt-1">{{ getError('new_password') }}</p>
                }
            </div>

            <div class="mb-4">
                <label cLabel for="confirm_password">Confirmar nueva contraseña</label>
                <input
                    cFormControl
                    type="password"
                    id="confirm_password"
                    formControlName="confirm_password"
                    placeholder="••••••••"
                    [class.is-valid]="isValid('confirm_password')"
                    [class.is-invalid]="isInvalid('confirm_password')"
                />
                @if (getError('confirm_password')) {
                    <p class="text-danger small mt-1">{{ getError('confirm_password') }}</p>
                }
            </div>

            <div class="d-grid">
                <button cButton color="primary" type="submit" [disabled]="isLoading()">
                    @if (isLoading()) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Actualizando...
                    } @else {
                        Establecer contraseña
                    }
                </button>
            </div>
        </form>
    </ng-container>
</app-auth-base-layout>
